import React from 'react';
import classNames from 'classnames';
import FolderActions from 'actions/inbox/FolderActions';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import ToastActions from '@store/toast/ToastActions';
import {errorCommunicating} from 'utils/const';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import './FolderList.styl';
import GenericLink from 'components/GenericLink';

export default class FolderList extends React.PureComponent {
  deleteFolder(folder) {
    confirm(`Are you sure you want to delete folder ${folder.name}?`).then(
      () =>
        FolderActions.deleteFolder(folder.id).then(
          () =>
            ToastActions.addToast({
              message: `Successfully deleted folder ${folder.name}`,
            }),
          () => ToastActions.addToast({message: errorCommunicating, type: 'error'})
        ),
      noop
    );
  }

  render() {
    const {folders} = this.props;
    return (
      <ul className="folder-list">
        {folders.size === 0 ? (
          <li>No folder found.</li>
        ) : (
          folders
            .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
            .map(folder => {
              const className = classNames({active: folder.id === this.props.filters.folderId});
              return (
                <li key={folder.id}>
                  <GenericLink
                    className={className}
                    onClick={() => this.props.onSelectFolder(folder.id)}>
                    {folder.name}{' '}
                    {folder.unviewedCount > 0 && <span>({folder.unviewedCount})</span>}
                  </GenericLink>
                  {!folder.isTrash() && <CloseIcon onClick={() => this.deleteFolder(folder)} />}
                </li>
              );
            })
        )}
      </ul>
    );
  }
}
